import { render, staticRenderFns } from "./AgentVerification.vue?vue&type=template&id=38f1a0e8"
import script from "./AgentVerification.vue?vue&type=script&lang=js"
export * from "./AgentVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports